import { request } from './index'
import { HTTP_METHODS } from './const'

class VisualImages {
  static getVisualImages(options) {
    return request({
      url: `v6/visual-screen`,
      method: HTTP_METHODS.get,
      params: {
        screen_name: options?.screen_name,
        screen_type: options?.screen_type,
      },
    }).catch((err) => err)
  }
}

export default VisualImages
